// src/components/sections/CTA.jsx
import React from 'react';
import Button from '../ui/button';

const CTA = () => {
  return (
    <section className="cta">
      <div className="container fade-in">
        <h2>Ready to Experience The Difference?</h2>
        <p>
          Join thousands of traders who are leveraging Solana's speed with Kinetix's advanced, MEV-protected infrastructure.
        </p>
        <Button variant="primary" className="pulse">Start Trading Now</Button>
      </div>
    </section>
  );
};

export default CTA;